export class AuthInfo {
  id : string;
  eMail: string;
  token: string;
  firstName: any;
  lastName: any;
}
